import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, first, map } from 'rxjs/operators';

import { automationapidata, AutomationList, AutomationSummery, Connector, Log, openAuthenticationconnector, OpenAuthenticationConnectorDetail, Result, Root } from '../_models';
//import { types, authconfiguration } from '@app/_models';
import { environment } from '../../environments/environment';
import { FillDDL } from '../_models';
import { Connection } from '../_models/connection';
import { error } from 'selenium-webdriver';
import { LastUSedToken } from '../_models/lastusedtoken';
import { FinalToken } from '../_models/finaltoken';


@Injectable({ providedIn: 'root' })
export class ConnectionService {
  postId = null;
  private connectorSubject: BehaviorSubject<Connector>;
  public connector: Observable<Connector>;

  constructor(
    private http: HttpClient
  ) {
    this.connectorSubject = new BehaviorSubject<Connector>(JSON.parse(localStorage.getItem('connectors')));
    this.connector = this.connectorSubject.asObservable();
  }

  public get connectionValue(): Connector {
    return this.connectorSubject.value;
  }
  getAll() {
    return this.http.get<Connector[]>(`${environment.apiUrl}/connection/getconnectors`);
  }
  getevent(cId: string, flag: string) {
    return this.http.get<FillDDL[]>(`${environment.apiUrl}/connection/getActionEvents?cid=${cId}&flag=${flag}`);
  }

  createconnection(connection: Connection) {
    return this.http.post<Result>(`${environment.apiUrl}/connection/addconnection`, connection);
  }

  // getAllAutomations(uid: string) {
  //   return this.http.get<AutomationList[]>(`${environment.apiUrl}/connection/getAutomations?uid=${uid}`);
  // }
  getAutomation(auid: string) {
    return this.http.get<AutomationList>(`${environment.apiUrl}/connection/getAutomation?auid=${auid}`);
  }
  remove(auId: string) {
    return this.http.post<Result>(`${environment.apiUrl}/connection/RemoveAutomation?auid=${auId}`, auId);
  }
  savedetail(connection: Connection) {
    return this.http.post<Result>(`${environment.apiUrl}/connection/addconnection`, connection);
  }
  SelectedConnectorDetail(uid: string) {
    return this.http.get<automationapidata>(`${environment.apiUrl}/connection/getAutomationapi?uid=${uid}`);
  }
  getSavedTriggerDetail(auid: string) {
    return this.http.get<Connection>(`${environment.apiUrl}/connection/getAuTriggerDetail?auid=${auid}`);
  }
  getSavedActionDetail(auid: string) {
    return this.http.get<Connection>(`${environment.apiUrl}/connection/getAuActionDetail?auid=${auid}`);
  }

  ActiveAutomation(auid: string,uId:string) {
    return this.http.get<Result>(`${environment.apiUrl}/connection/ActiveAutomation/${auid}/${uId}`)
      .pipe(map(Result => {

        return Result;

      }));
  }

  removeentry(auId: string, flg: string) {
    return this.http.post<Result>(`${environment.apiUrl}/connection/RemoveAutomationentry?auid=${auId}&flag=${flg}`, auId);
  }
  GetQ2ETriggerAuthenticate(url: string, key: string): Observable<any> { 
   // return this.http.post<any>(`${environment.apiUrl}/connection/CheckToken`, { Token: key, RequestURL: url });
     return this.http.get<any>(`${url}/${key}`).pipe(catchError(this.handleError));
  }
  Error_Log(exception: string) {
    return this.http.post<Result>(`${environment.apiUrl}/connection/ErrorLog`, { exception });
  }
  handleError(error) {
    // window.alert(error);
    return throwError(error.message || 'Server Error');
  }

  getAutomationSummeryDetail(auid) {
    return this.http.post<AutomationSummery[]>(`${environment.apiUrl}/connection/AutomationSummery`, { auid });
  }

  getLastUsedTiken(cId, uId) {
    return this.http.get<LastUSedToken>(`${environment.apiUrl}/connection/GetLastUsedToken?cId=${cId}&uId=${uId}`);
  }

  postSlackOpenAuthentication(client_id, client_secret, accesstokenrequrl, code, redirect_uri) {
    //  const SlackURL: string = 'https://slack.com/api/oauth.v2.access';      
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http.get<FinalToken>(`${accesstokenrequrl}?client_id=${client_id}&client_secret=${client_secret}&code=${code}&redirect_uri=${redirect_uri}`, { headers }).pipe(catchError(this.handleError));
    // return this.http.post<any>(`${SlackURL}`, { client_id, client_secret, code, redirect_uri  }, { headers: headers }).pipe(catchError(this.handleError));

  }
  posteamOpenAuthentication(Code, uId, auid, client_id, client_secret, redirect_uri) {

    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http.post<any>(`${environment.apiUrl}/connection/postTeamAcessToken`, { Code, uId, auid, client_id, client_secret, redirect_uri });
    // return this.http.post<any>(`${SlackURL}`, { client_id, client_secret, code, redirect_uri  }, { headers: headers }).pipe(catchError(this.handleError));

  }

  handleError1(error: HttpErrorResponse) {
    let errorMessage = 'Unknown error!';
    if (error.error instanceof ErrorEvent) {
      errorMessage = `Error: ${error.error.message}`;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    //  window.alert(errorMessage);
    return throwError(errorMessage);
  }

  PostRefereshTokenTrigger(auid, cid, FinalToken) {
    return this.http.post<Result>(`${environment.apiUrl}/connection/AddRefreshTokenTrigger`, { auid, cid, FinalToken });
  }
  PostRefereshTokenAction(auid, cid, FinalToken) {


    return this.http.post<Result>(`${environment.apiUrl}/connection/AddRefreshTokenAction`, { auid, cid, FinalToken });
  }
  getconnectoropenAuthentication(auid: string, connetorFor: string) {
    return this.http.post<openAuthenticationconnector>(`${environment.apiUrl}/connection/getConnectorForOpenAuthentication`, { auid, connetorFor });

  }

  getActiveAtomationIds(userId:number, automationId:number) {
    return this.http.post<any>(`${environment.apiUrl}/connection/getActiveAtomationIds`, { userId: userId, automationId: automationId });

  }

  getOpenAuthenticationConnectorDetail(uid: string) {
    return this.http.get<OpenAuthenticationConnectorDetail>(`${environment.apiUrl}/connection/getOpenAuthenticationConnectorDetail?uid=${uid}`);

  }

  RevokeAuthorization(automationId: number) {
    return this.http.get<any>(`${environment.apiUrl}/connection/RevokeAuthorization?automationId=${automationId}`);

  }


  PostChatMessage() {


    const channel = '@dtiplvip';
    const text = 'asdsadsad';
    const chatpostURL = 'https://slack.com/api/chat.postMessage';

    const token =
      'xoxb-1023067552646-2135994777890-VPrgzFbtjD3E1DOjYK7fR1DM';

    //return this.http.get<Root>(`${chatpostURL}?channel=${channel}&text=${text}`, { headers }).pipe(catchError(this.handleError1));
    const headers = new HttpHeaders()

      .set('Content-Type', 'application/json')
      .set('autherization', `Bearer ${token}`);

    //const body = { channel: channel, text: text  };
    //this.http.post<any>(chatpostURL, body, { headers }).subscribe(data => {
    //  this.postId = data.id;
    //});
    return this.http.post<any>(`${chatpostURL}?channel=${channel}&text=${text}`, { headers }).pipe(first()).
      subscribe(data => {
        this.postId = data.id;
      });
  }
  //async PostMessagefromchanneltoBot() {


  //  const { WebClient, LogLevel } = require("@slack/web-api");
  //  const client = new WebClient("xoxb-your-token", {
  //    // LogLevel can be imported and used to make debugging simpler
  //    logLevel: LogLevel.DEBUG
  //  });
  //  const channelId = "C12345";

  //  try {
  //    // Call the chat.postMessage method using the WebClient
  //    const result = await client.chat.postMessage({
  //      channel: channelId,
  //      text: "Hello world"
  //    });

  //    console.log(result);
  //  }
  //  catch (error) {
  //    console.error(error);
  //  }

  //}
}
